module.exports = __webpack_public_path__ + "img/home-left.8f7ba36b.png";